<template>
    <div
      :class="[ 'flex items-start relative py-4 px-5 font-heading', inline ? '' : 'rounded-xl shadow-sm', centered ? 'justify-center text-center' : 'justify-start', variantClasses[variant] ]"
      role="alert"
    >
      <InfoIcon v-if="showInfoIcon" class="w-7 h-7 flex-shrink-0 text-current mt-1 mr-3" aria-hidden="true" />
      <div :class="[ 'text-sm', closeable ? 'pr-8' : '' ]">
        <span v-if="message" v-html="$t(message)" />
        <slot />
      </div>
      <button
        v-if="closeable"
        v-tippy="$t('text-close')"
        data-dismiss="alert"
        :class="[ '-me-0.5 -mt-3 flex items-center justify-center rounded-full flex-shrink-0 w-6 h-6 absolute end-2 top-1/2 transition-colors duration-200 hover:bg-gray-300 hover:bg-opacity-25 focus:outline-none focus:bg-gray-300 focus:bg-opacity-25', variantClasses[variant] ]"
        @click="onClose"
      >
        <span aria-hidden="true">
          <CloseIcon class="w-4 h-4" />
        </span>
      </button>
    </div>
</template>

<script setup>
import CloseIcon from "@components/icons/close-icon";
import InfoIcon from "@components/icons/outline/info-circle";

const variantClasses = {
  dark: "alert-dark",
  light: "alert-light",
  info: "alert-info",
  warning: "alert-warning",
  error: "alert-error",
  success: "alert-success",
  infoOutline: "alert-info-outline",
  warningOutline: "alert-warning-outline",
  errorOutline: "alert-error-outline",
  successOutline: "alert-success-outline",
};

defineProps({
    message: {
        type: String,
        default: '',
    },
    closeable: {
        type: Boolean,
        default: false
    },
    inline: {
        type: Boolean,
        default: false
    },
    centered: {
        type: Boolean,
        default: false
    },
    showInfoIcon: {
        type: Boolean,
        default: false
    },
    variant: {
        type: String,
        default: 'info' // "info" | "warning" | "error" | "success" | "infoOutline" | "warningOutline" | "errorOutline" | "successOutline"
    },
    onClose: {
        type: Function,
        default: () => { }
    }
})

</script>
